<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.departments')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row">
                    <div class="col-md-8">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.staffDepartmentList')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="staffDepartments.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.name')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(department, index) in staffDepartments" :key="index">
                                            <td>{{department.name}}</td>

                                            <td class="text-right">
                                                <button v-if="permissions.editSettingsDepartments"
                                                    class="btn btn-info btn-sm" @click="edit(department, 'staff')">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteSettingsDepartments"
                                                    class="btn btn-danger btn-sm" @click="remove(department, index)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="staffDeptPagination.last_page > 1" :pagination="staffDeptPagination"
                                :offset="5" @paginate="paginate()">
                            </pagination>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="card" v-if="toggleForm">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.departmentCreate')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <b-form-group :label="$t('form.setting.addInList')">
                                    <b-form-radio v-model="type" value="staff">{{$t('form.setting.inputStaff')}}
                                    </b-form-radio>
                                    <b-form-radio v-model="type" value="professor">{{$t('form.setting.inputProfessor')}}
                                    </b-form-radio>
                                </b-form-group>

                                <b-button variant="primary" @click="submit">{{$t('button.save')}}</b-button>
                            </div>
                        </div>

                        <div class="card" v-else>
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.departmentEdit')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <b-button variant="primary" @click="update">{{$t('button.update')}}</b-button>
                                <b-button variant="outline-primary" @click="cancel">{{$t('button.cancel')}}</b-button>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-8">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.professorDepartmentList')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="professorDepartments.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.name')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(department, index) in professorDepartments" :key="index">
                                            <td>{{department.name}}</td>

                                            <td class="text-right">
                                                <button v-if="permissions.editSettingsDepartments"
                                                    class="btn btn-info btn-sm" @click="edit(department, 'professor')">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteSettingsDepartments"
                                                    class="btn btn-danger btn-sm"
                                                    @click="remove(department, index, 'professor')">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="profDeptPagination.last_page > 1" :pagination="profDeptPagination"
                                :offset="5" @paginate="paginate('professor')">
                            </pagination>
                        </div>
                    </div>
                </div>

                <div class="row">
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                toggleForm: true,

                staffDeptPagination: {
                    current_page: 1
                },
                profDeptPagination: {
                    current_page: 1
                },

                name: '',
                id: '',
                type: 'staff',

                staffDepartments: [],
                professorDepartments: []
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsDepartments) {
                return this.$router.push('/');
            }

            this.getStaffDepartments();
            this.getProfessorDepartments();
        },

        methods: {

            getProfessorDepartments() {
                this.isLoading = true;

                axios
                    .get('/api/departments?type=professor&page=' + this.profDeptPagination.current_page)
                    .then(response => {
                        this.professorDepartments = response.data.data.data;
                        this.profDeptPagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            getStaffDepartments() {
                this.isLoading = true;

                axios
                    .get('/api/departments?type=staff&page=' + this.staffDeptPagination.current_page)
                    .then(response => {
                        this.staffDepartments = response.data.data.data;
                        this.staffDeptPagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate(type = null) {

                if (type) {
                    this.getProfessorDepartments();
                    return;
                }

                this.getStaffDepartments();
            },

            submit() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .post(`/api/departments`, {
                        name: this.name,
                        type: this.type
                    })
                    .then(response => {

                        if (response.data.success) {
                            this.name = '';
                            this.showAlert(response.data.message);

                            if (this.type == 'staff') {
                                this.staffDepartments.unshift(response.data.data);
                            } else {
                                this.professorDepartments.unshift(response.data.data);
                            }
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message,'danger');
                        }

                        this.isLoading = false;
                    })
            },

            edit(item, type) {
                this.id = item.id;
                this.name = item.name;
                this.type = type;
                this.toggleForm = false;
            },

            update() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .put(`/api/departments/${this.id}`, {
                        name: this.name,
                        type: this.type
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            if (this.type == 'professor') {
                                this.professorDepartments.map(r => {
                                    if (r.id == this.id) {
                                        r.id = response.data.data.id;
                                        r.name = response.data.data.name;
                                    }
                                });
                            } else {
                                this.staffDepartments.map(r => {
                                    if (r.id == this.id) {
                                        r.id = response.data.data.id;
                                        r.name = response.data.data.name;
                                    }
                                });
                            }

                            this.cancel();
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message,'danger');
                        }

                        this.isLoading = false;
                    })
            },

            cancel() {
                this.id = '';
                this.name = '';
                this.type = 'staff';
                this.toggleForm = true;
            },

            remove(item, index, type = null) {
                if (!confirm(this.$t('form.validation.delete'))) {
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .delete(`/api/departments/${item.id}`)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            if (type) {
                                this.professorDepartments.splice(index, 1);
                                return;
                            }

                            this.staffDepartments.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            clear() {
                this.alert = false;
                this.message = '';
                this.alertClass = '';
            }
        }
    }

</script>
